import { ListMenu, SearchInput } from "@finanedi.es/storybook"
import { GetAllEmpresasGestionadasVerificadasUsuarioDtoProps } from "api/DTOs/GetAllEmpresasGestionadasVerificadasUsuarioDto"
import { GetAllEmpresasUsuarioDtoProps } from "api/DTOs/GetAllEmpresasUsuarioDto"
import { TIPO_EMPRESA_USUARIO } from "api/Types/TipoEmpresa"
import {
  useGetAllEmpresasGestionadasVerificadasUsuario,
  useGetUsuarioByCurrentUser,
  useUsuarioEmpresaActiva,
  useUsuarioEmpresas,
} from "api/Usuario.hook"
import { Tabs } from "common/components/Tabs"
import { USER_COMPANIES_LIST } from "common/components/UserMenu/constant"
import useCambiarEmpresa from "features/MisEmpresas/hooks/useCambiarEmpresa"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

export const NavbarAsesoria = () => {
  const { t } = useTranslation()
  const {
    usuario: { empresaActiva, asesoriaActivaId },
  } = useGetUsuarioByCurrentUser()
  const isAsesoria =
    empresaActiva?.tipoEmpresa === TIPO_EMPRESA_USUARIO.ASESORIA ||
    asesoriaActivaId
  const {
    activeCompany: { id: empresaActivaId },
  } = useUsuarioEmpresaActiva()
  const {
    usuarioEmpresas: { items: empresas },
  } = useUsuarioEmpresas()
  const {
    usuarioEmpresasGestionadas: { items: empresasGestionadas },
  } = useGetAllEmpresasGestionadasVerificadasUsuario({
    tipoEmpresa: isAsesoria ? TIPO_EMPRESA_USUARIO.ASESORIA : undefined,
  })
  const { setEmpresaActiva } = useCambiarEmpresa()
  const [tabList, setTabList] = useState<
    | Array<
        | GetAllEmpresasGestionadasVerificadasUsuarioDtoProps
        | GetAllEmpresasUsuarioDtoProps
      >
    | undefined
    | null
  >()
  const [keyword, setKeyword] = useState<string>()
  const [tabMotive, setTabMotive] = useState<string>()
  const filteredListByKeyword = keyword
    ? tabList?.filter(
        (
          empresa:
            | GetAllEmpresasGestionadasVerificadasUsuarioDtoProps
            | GetAllEmpresasUsuarioDtoProps
        ) => empresa.razonSocial?.toLowerCase().includes(keyword?.toLowerCase())
      )
    : tabList

  useEffect(() => {
    isAsesoria ? setTabList(empresasGestionadas) : setTabList(empresas)
    setTabMotive(
      isAsesoria
        ? `${t("menuUser.motives.manage")}`
        : `${t("menuUser.motives.use")}`
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresasGestionadas?.length, empresas?.length, isAsesoria])

  return (
    <>
      <div className='tw-flex tw-flex-col tw-w-full tw-p-4 tw-gap-2'>
        <div className='tw-text-left tw-text-lg tw-text-secondary tw-font-bold tw-uppercase'>
          {t("menuUser.titleCompany")}
        </div>
        <div className='tw-text-left'>
          {t("menuUser.companyChoice", {
            motive: tabMotive,
          })}
        </div>
        {isAsesoria && (
          <Tabs
            tabs={[
              {
                key: "tab1",
                children: t("menuUser.tabs.managed"),
                onClickAction: () => {
                  setTabMotive(`${t("menuUser.motives.manage")}`)
                  setTabList(empresasGestionadas)
                },
              },
              {
                key: "tab2",
                children: t("menuUser.tabs.owned"),
                onClickAction: () => {
                  setTabMotive(`${t("menuUser.motives.use")}`)
                  setTabList(empresas)
                },
              },
            ]}
          />
        )}
        <SearchInput
          placeholder={`${t("empresasGestionadas.header.searchPlaceholder")}`}
          onChange={(ev: string) => {
            setKeyword(ev)
          }}
          inputValue={keyword}
          className='tw-h-10 tw-w-full'
        />
      </div>
      {filteredListByKeyword?.length ? (
        <ListMenu
          sectionList={USER_COMPANIES_LIST(
            setEmpresaActiva,
            filteredListByKeyword,
            empresaActivaId,
            asesoriaActivaId
          )}
        />
      ) : (
        <div className='tw-pb-4'>{t("menuUser.tabs.empty")}</div>
      )}
    </>
  )
}
